import * as yup from 'yup';

import {TFunction} from 'i18next';
import {locationShape} from '@/schemas/sub-schemas';

export const TITLE_MAX_LENGTH = 50;
const TITLE_MIN_LENGTH = 2;
export const DESC_MAX_LENGTH = 1000;

const GroupValidationSchema = (t: TFunction, trainerInSjOne = false) =>
  yup.object({
    title: yup
      .string()
      .required(
        t('validation:is_required', {
          name: t('the_title')
        }) || undefined
      )
      .min(
        TITLE_MIN_LENGTH,
        t('validation:min_length', {
          name: t('the_title'),
          min: TITLE_MIN_LENGTH
        }) || undefined
      )
      .max(
        TITLE_MAX_LENGTH,
        t('validation:max_length', {
          name: t('the_title'),
          max: TITLE_MAX_LENGTH
        }) || undefined
      ),
    description: yup
      .string()
      .required(
        t('validation:is_required', {
          name: t('description')
        }) || undefined
      )
      .max(
        DESC_MAX_LENGTH,
        t('validation:max_length', {
          name: t('description'),
          max: DESC_MAX_LENGTH
        }) || undefined
      ),
    accessType: yup.string().required().oneOf(['PUBLIC', 'PRIVATE']),
    sports: yup.array().of(yup.string()),
    location: locationShape({t, name: t('location')}).required(
      t('validation:is_required', {
        name: t('location')
      })
    ),
    company: trainerInSjOne
      ? yup.string().required(
          t('validation:is_required', {
            name: t('company')
          }) || undefined
        )
      : yup.string().notRequired()
  });
export type GroupSchemaData = yup.InferType<
  ReturnType<typeof GroupValidationSchema>
>;

export default GroupValidationSchema;
